module.exports = __webpack_public_path__ + "img/Sakralbau_2_a.0b194eb7.jpg";